import formatDuration from 'date-fns/formatDuration';
import intervalToDuration from 'date-fns/intervalToDuration';

import { DateLike } from './types';

export default function getDuration(start: DateLike, end: DateLike) {
  return formatDuration(intervalToDuration({ start: new Date(start), end: new Date(end) }));
}
